export default {
  treatYourselfDesktop: {
    en: 'Treat yourself this holiday season! Get {discount} off and a free case',
  },
  treatYourselfMobile: {
    en: 'Treat yourself this holiday season!',
  },
}
